import { render, staticRenderFns } from "./DataReportOrdenesGeneradas.vue?vue&type=template&id=25706a3c"
import script from "./DataReportOrdenesGeneradas.vue?vue&type=script&lang=js"
export * from "./DataReportOrdenesGeneradas.vue?vue&type=script&lang=js"
import style0 from "./DataReportOrdenesGeneradas.vue?vue&type=style&index=0&id=25706a3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports